import {Dispatch, PropsWithChildren, useReducer} from "react";
import {createContext} from "../../../../../../context/create-context";
import {
  initialUserScheduleState,
  userScheduleReducer,
} from "../../reducers/user-schedule";
import {UserScheduleActions} from "../../reducers/user-schedule/types";

type UserScheduleContextState = {
  state: typeof initialUserScheduleState;
  dispatch: Dispatch<UserScheduleActions>;
};

const [useContext, ContextProvider] = createContext<UserScheduleContextState>();

export const useUserScheduleContext = useContext;

export const UserScheduleProvider = ({children}: PropsWithChildren) => {
  const [state, dispatch] = useReducer(userScheduleReducer, initialUserScheduleState);
  return <ContextProvider value={{state, dispatch}}>{children}</ContextProvider>;
};
